<template>
  <div class="detail-box">
    <div class="detail-title">
      <div class="detail-title-big">{{pageTitle}}</div>
      <div class="detail-title-small">{{pageTitle}}</div>
    </div>
    <div class="detail-info">
      <div class="detail-info-title">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="(item,index) of humList" :key="index">{{ item.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="detail-info-content">
        <div class="detail-info-content-title">{{ pageInfo.bt }}</div>
        <div class="detail-info-content-info">
          <div class="detail-info-content-info-item">创建时间：{{ pageInfo.createTime }}</div>
          <div class="detail-info-content-info-item">阅读量：{{ pageInfo.readNum }}</div>
        </div>
        <div class="detail-info-content-detail" v-html="pageInfo.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // beforeRouteEnter(to, from, next) {
  //   console.log(to,from,11111)

  //   next(vm => {
  //     console.log(vm)
  //     // 通过 `vm` 访问组件实例
  //     vm.humList = [...from.matched,...to.matched]
  //     vm.fromPage = from.matched[from.matched.length-1]
  //   });
  //   // 在渲染该组件的对应路由被 confirm 前调用

  // },
  components: {},
  data() {
    return {
      tableData: [],
      listType: 1,
      currentPage: 1,
      humList: [],
      total: 0,
      pageTitle: '',
      pageInfo:{

      }
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.humList = [
      ...this.$Lockr.get('fromPage'),
      ...this.$Lockr.get('toPage')
    ]

    this.getDetail(this.$route.params.id)
  },
  methods: {
    getDetail(id) {
      this.axios
        .get(`https://admin.jshtcq.com/api/sy/notice/${id}`)
        .then(res => {
          switch (res.data.data.category) {
            case 1:
              this.pageTitle = '公司动态'
              // 执行代码块 1
              break
            case 2:
              this.pageTitle = '行业资讯'
              // 执行代码块 2
              break
            case 3:
              this.pageTitle = '通知公告'
              // 执行代码块 2
              break
            case 4:
              this.pageTitle = '政策法规'
              // 执行代码块 2
              break
            case 5:
              this.pageTitle = '交易流程'
              // 执行代码块 2
              break
            case 6:
              this.pageTitle = '竞价须知'
              // 执行代码块 2
              break
            case 7:
              this.pageTitle = '文件下载'
              // 执行代码块 2
              break
            case 8:
              this.pageTitle = '企业文化'
              // 执行代码块 2
              break
            case 9:
              this.pageTitle = '联系我们'
              // 执行代码块 2
              break
            case 10:
              this.pageTitle = '在线咨询'
              // 执行代码块 2
              break
            default:
              // 如果没有匹配到任何 case，则执行默认代码块
              break
          }
          this.pageInfo = res.data.data
        })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-submenu.is-active .el-submenu__title {
    border-bottom-color: #409eff;
    color: #0c6aec !important;
  }
}
.detail-box {
  background: #f7f7f7;

  .detail-title {
    width: 100%;
    height: 250px;
    background: url('./../assets/jsht/detail/detail_top_bg.png') left top
      no-repeat;
    background-size: 100% 100%;
    position: relative;
    .detail-title-big {
      font-family: YouSheBiaoTiHei;
      font-size: 150px;
      color: rgba(0, 101, 240, 0.12);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 195px;
      line-height: 195px;
      margin-top: 16px;
    }
    .detail-title-small {
      font-family: YouSheBiaoTiHei;
      font-size: 52px;
      color: #0c6aec;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 68px;
      line-height: 68px;
      margin-top: 108px;
    }
  }

  .detail-info {
    padding: 0 240px;

    .detail-info-title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 52px;

      .detail-info-title-right {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
      }
    }

    .detail-info-content {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      padding-bottom: 36px;
      .detail-info-content-title {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        font-size: 24px;
        color: #1e1e1e;
      }
      .detail-info-content-info {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-weight: 400;
        font-size: 18px;
        color: #898989;
        margin-top: 16px;
        .detail-info-content-info-item + .detail-info-content-info-item {
          margin-left: 100px;
        }
      }
      .detail-info-content-detail{
        margin-top: 12px;
        background: #ffffff;
        padding: 0 10px;
      }

    }
  }
}
</style>